import { useStoreActions } from "../../../contexts";
import { useMutationState } from "../../../hooks/reactQuery/useMutationState";
export const useUpdateOnboardingState = () => {
  const {
    api
  } = useStoreActions();
  const {
    mutate
  } = useMutationState({
    mutationFn: _ref => {
      let {
        businessId,
        onboardingWidgetState
      } = _ref;
      return api.business.updateBusinessOnboardingWidgetState(businessId, onboardingWidgetState);
    },
    retry(failureCount, _) {
      return failureCount < 3;
    },
    retryDelay: _ => 1000
  });
  return {
    updateOnboardingState: mutate
  };
};